import { render, staticRenderFns } from "./BoxHeader.html?vue&type=template&id=ca6495fc&external"
import script from "./BoxHeader.ts?vue&type=script&lang=ts&external"
export * from "./BoxHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./BoxHeader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports